const themeContractM011 = {
  tu: {
    border: {
      width: 'md',
      style: 'solid',
      color: 'grey-20'
    },
    background: {
      color: ''
    }
  },
  argos: {
    border: {
      width: 'sm',
      style: 'solid',
      color: 'grey-60'
    },
    background: {
      color: ''
    }
  },
  habitat: {
    border: {
      width: 'sm',
      style: 'solid',
      color: 'grey-60'
    },
    background: {
      color: ''
    }
  },
  nectar: {
    border: {
      width: '',
      style: '',
      color: ''
    },
    background: {
      color: 'white'
    }
  },
  sainsburys: {
    border: {
      width: 'sm',
      style: 'solid',
      color: 'grey-60'
    },
    background: {
      color: 'white'
    }
  }
}

export { themeContractM011 }
